import styled from '@emotion/styled';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/rootReducer';

export function LogoBox() {
  const logo = useSelector((state: RootState) => state.block.block.logo);

  return (
    <LogoBoxWrapper>
      <img src={logo} />
      <LogoText>SELF PHOTO STUDIO</LogoText>
    </LogoBoxWrapper>
  );
}

const LogoBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: fit-content;

  > img {
    width: 600px;
    height: 120px;
  }
`;

const LogoText = styled.h3`
  font-size: 48px;
  font-weight: 600;
  line-height: 60px;
  color: ${({ theme }) => theme.color[2]};
`;
